import { render, staticRenderFns } from "./MatchPreview.vue?vue&type=template&id=1f285ecc&"
import script from "./MatchPreview.vue?vue&type=script&lang=js&"
export * from "./MatchPreview.vue?vue&type=script&lang=js&"
import style0 from "./MatchPreview.vue?vue&type=style&index=0&id=1f285ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports